module.exports = __webpack_public_path__ + "img/logoSintacluns.fcfd1a3e.png";